function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 0.5,
  y: 45.5,
  width: 45,
  height: 45,
  rx: 22.5,
  transform: "rotate(-90 0.5 45.5)",
  fill: "#0053CB",
  stroke: "#DFDFE8"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5.61108,
  y: 40.3887,
  width: 34.7778,
  height: 34.7778,
  rx: 17.3889,
  transform: "rotate(-90 5.61108 40.3887)",
  fill: "#0053CB",
  stroke: "#DFDFE8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5872 29.0942C21.1791 29.4874 20.5192 29.4874 20.1111 29.0942C19.7037 28.701 19.7037 28.0638 20.1111 27.6706L24.9532 23.0006L20.1111 18.3298C19.7037 17.9366 19.7037 17.2994 20.1111 16.9062C20.5192 16.513 21.1791 16.513 21.5872 16.9062L27.1667 22.2888C27.5741 22.682 27.5741 23.3191 27.1667 23.7124L21.5872 29.0942Z",
  fill: "white"
});

function SvgCaretRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret_right.c621a41c.svg";
export { ForwardRef as ReactComponent };